import React from "react";
import { graphql } from "gatsby";
import moment from "moment";
import Layout from "components/Layout";
import Seo from "components/Seo";

import SubpageHeader from "components/SubpageHeader";
import NewsMainTile from "components/NewsMainTile";
import NewsTile from "components/NewsTile";

import "styles/pages/page-news.scss";

const NewsPage = ({ pageContext, data }) => {
  const seo = pageContext.seo;
  const lang = pageContext.language?.slug;
  const articles = data.allWpPost.nodes;
  const articlesFilteredByLang = articles.filter((el) => {
    return el.language.slug === lang;
  });

  return (
    <Layout lang={lang}>
      <Seo
        title={seo.title ? seo.title : pageContext.title}
        description={seo.metaDesc}
      />
      <SubpageHeader lang={lang} title={pageContext.title} />
      <section className="section-news">
        <div className="container">
          <div className="row">
            {articlesFilteredByLang.map((item, index) => {
              return index === 0 ? (
                <div key={index} className="col-12 section-news__tile-main">
                  <NewsMainTile
                    date={item.date}
                    image={item.featuredImage?.node.sourceUrl}
                    title={item.title}
                    desc={item.postAcf.shortDesc}
                    link={item.uri}
                    lang={lang}
                  />
                </div>
              ) : (
                <div
                  key={index}
                  className="col-xl-4 col-lg-6 section-news__tile"
                >
                  <NewsTile
                    date={item.date}
                    image={item.featuredImage?.node.sourceUrl}
                    title={item.title}
                    desc={item.postAcf.shortDesc}
                    link={item.uri}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query {
    allWpPost(sort: { fields: date, order: DESC }) {
      nodes {
        postAcf {
          shortDesc
        }
        date(formatString: "DD-MM-yyyy")
        uri
        title
        language {
          slug
        }
        featuredImage {
          node {
            sourceUrl
          }
        }
      }
    }
  }
`;

export default NewsPage;
